import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import wechat from './modules/wechat'
import baw from './modules/baw'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    user,
    wechat,
    baw
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js